import { AxiosInstance } from 'axios'
import { Identifier, ListOptions, PaginatedResult } from './_types'
import { Clinic } from './clinic'

export enum LinkStatus {
  WAITING = 'AGUARDANDO',
  APPROVED = 'APROVADO',
  DISAPPROVED = 'REPROVADO',
  INACTIVATED = 'INATIVADO',
  REACTIVATED = 'REATIVADO',
}

export type PharmaceuticalTaskforceOriginMessage = Identifier & {
  message: string
}

export type ClinicTaskforceLink = {
  id: number
  uuid: string
  clinicId: number
  pharmaceuticalTaskforceOriginMessageId: number
  status: LinkStatus
  reason: string | null
  createdAt: string

  clinic: Clinic | null
  message: PharmaceuticalTaskforceOriginMessage | null
  // taskforceAnswers: TaskforceAnswer[]
  // clinicTaskforceLinkDocuments: ClinicTaskforceLinkDocument[]
}

export function clinicTaskforceLinkEndpoints(apiClient: AxiosInstance) {
  return {
    async list({
      filters,
      pagination,
      relations,
      sort,
    }: ListOptions<ClinicTaskforceLink, 'status', 'id' | 'createdAt', 'clinic' | 'message'>): Promise<
      PaginatedResult<ClinicTaskforceLink>
    > {
      return apiClient.get('list-clinic-links', {
        params: {
          pagination: pagination ? JSON.stringify(pagination) : undefined,
          filters: filters ? JSON.stringify(filters) : undefined,
          relations: relations ? JSON.stringify(relations) : undefined,
          sort: sort ? JSON.stringify(sort) : undefined,
        },
      })
    },
  }
}
